import ManualAttendanceIcon from '@material-ui/icons/ViewList';

import ManualAttendanceList from './ManualAttendanceList';

export default {
  list: ManualAttendanceList,
  icon: ManualAttendanceIcon,
};
